export const PIXEL_WIDGET_URL = 'pixel/widget';

export const PIXEL_EVENTS_URL = 'pixel/events';

export const PIXEL_EVENTS_OVERVIEW_URL = 'pixel/events/overview';

export const PIXEL_EVENTS_EXPORT_URL = 'pixel/events/export';

export const PIXEL_EVENTS_DAILY_URL = 'pixel/events/daily';

// Pixel Config API URLs
export const PIXEL_CONFIG_URL = 'pixel/advertiser';

// Pixel CDN URL for script tag
export const PIXEL_CDN_URL =
  process.env.REACT_APP_PIXEL_CDN_URL || 'https://tracker.tracepixels.com/pixel.js';

// Pixel server-side (S2S) endpoint used by the installation guide snippets
export const PIXEL_S2S_URL =
  process.env.REACT_APP_PIXEL_S2S_URL || 'https://pixel.dashboard.coolmedia.co';
